import Portfolio from './Portfolio';

function App() {
  return (
    <div>
      <Portfolio />
    </div>
  );
}

export default App;